<script lang="ts">
	import YouTubeEmbed from '$lib/components/ui/YouTubeEmbed.svelte';
	import type { VideoDetails } from '$lib/features/_other/videoDetails.type';

	const { videos, englishName }: { videos: VideoDetails[]; englishName: string } = $props();
</script>

<div class="scrollbar-hide snap-x snap-mandatory overflow-x-auto">
	<div class="flex gap-3">
		{#each videos as video (video.youtubeId)}
			<div
				id={video.youtubeId}
				class="relative shrink-0 snap-center snap-always overflow-hidden rounded-box lg:snap-start lg:snap-normal"
			>
				<div class="aspect-video w-75 overflow-hidden lg:w-100">
					<YouTubeEmbed videoId={video.youtubeId} playLabel="Explore {englishName}" />
				</div>
			</div>
		{/each}
	</div>
</div>
